import { CategorizationLayout } from '../../../components/Categorization';
import { PermissionKey } from '../../../types';

export function Boards() {
  return (
    <CategorizationLayout
      type="board"
      translationContext="male"
      omitFields={['abbreviation', 'searchKeywords']}
      permissions={{ keys: PermissionKey.AdminManageContacts }}
    />
  );
}
